// app/[locale]/native-tapioca-starch-manufacturing-process/ProcessClient.tsx
"use client";

import Hero from "@/app/components/native-tapioca-starch-manufacturing-process/Hero";
import ProcessSteps from "@/app/components/native-tapioca-starch-manufacturing-process/ProcessSteps";
import FooterContact from "@/app/components/FooterContact";

export default function ProcessClient() {
  return (
    <>
      <Hero />
      <ProcessSteps />
      <FooterContact />
    </>
  );
}
